export default function HelmetIcon(props) {
  return (
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M2.4033 8.44141H10.7583C10.9422 8.44155 11.1228 8.49047 11.2816 8.58316C11.4404 8.67586 11.5719 8.80902 11.6625 8.96907C11.7531 9.12912 11.7996 9.31033 11.7973 9.49423C11.795 9.67813 11.744 9.85813 11.6495 10.0159L9.77759 13.1357C9.68531 13.2898 9.55472 13.4173 9.39853 13.5058C9.24235 13.5944 9.0659 13.641 8.88635 13.6412H2.19531"
        stroke="inherit"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7766 10.5683C17.7963 14.6824 15.6967 17.8022 11.5566 17.8022H5.31691C4.48947 17.8022 3.69593 17.4735 3.11084 16.8884C2.52575 16.3034 2.19706 15.5098 2.19706 14.6824V10.2917C2.17514 9.24865 2.35995 8.21158 2.74083 7.2403C3.1217 6.26902 3.6911 5.38276 4.41619 4.63263C5.14128 3.88251 6.0077 3.28336 6.96549 2.86974C7.92328 2.45612 8.95349 2.23622 9.99669 2.22273C15.7164 2.20297 17.7558 6.36277 17.7766 10.5683Z"
        stroke="inherit"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
